<!--
/*******************************************************************************
*@ 화면명   : LvbdInfoValdnPopup.vue
*@ 화면설명 : 생체검증시 팝업
*@ 사용전문     :  
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2024.05.28  최지영
********************************************************************************/
-->
<template>
  <section>
    <modal-pop
      :opened.sync="lvbdInfoRegiYnPopupOpen"
      :modalHeader="true"
      :modalFooter="true"
      :btnClose="true"
      :titleCenter="true"
      :title="/*생체정보검증*/$t('FIDO-0016')"
    >
      <template #content>
        {{ /*해당 거래는 생체정보검증이 필요합니다.*/ $t("FIDO-0029") }}
        {{ /*생체정보 등록 후 다시 거래해주시기 바랍니다.*/ $t("FIDO-0030") }}
      </template>
      <template #footer>
        <button
          class="btn bottom positive"
          @click="() =>{ $router.push({ name: 'createEkycEnter' }) }"
        >{{ /*등록하기*/ $t("FIDO-0031") }}</button>
      </template>
    </modal-pop>
    <modal-pop
      :opened.sync="scanSelfieDataNoMatch"
      :modalHeader="true"
      :modalFooter="true"
      :title="/*생체정보검증*/$t('FIDO-0016')"
      class="modal"
    >
      <template #content>
        <div>
          <!-- fail -->
          <div class="ekyc content-header">
            <div class="title-img">
              <i class="icon icon-img-char02"></i>
            </div>
            <div class="title">
              <h5>{{ /*죄송합니다.*/ $t("FIDO-0022") }}</h5>
            </div>
            <div class="description">
              {{ /*생체정보검증에 실패하였습니다.*/ $t("FIDO-0023") }}
              <br />
              {{ /*재시도하거나 영업점에 방문해주시기 바랍니다.*/ $t("FIDO-0024") }}
            </div>
          </div>
          <!-- // fail -->
        </div>
      </template>
      <template #footer>
        <button
          class="btn bottom positive"
          @click="scanSelfieDataNoMatch = false"
        >{{ /*확인*/ $t("FIDO-0025") }}</button>
      </template>
    </modal-pop>
  </section>
</template>
<script>
import Common from "@/components/basic/Common";
import { mapFields } from "vuex-map-fields";
export default {
  name: "LvbdInfoValdnPopup",
  extends: Common,
  computed: {
    ...mapFields(["sessionInfo"]),
    ...mapFields("native", ["scanSelfieDataMatch"]),
    openOtpPopup: function () {
      return this.scanSelfieDataMatch;
    },
  },
  watch: {
    openOtpPopup(value) {
      if (value === "MATCH") {
        this.$post("/auth/fido/certn/LvbdInfoValdnFnsh", { valdnId: this.$parent.valdnId, mchtlUniqNo: this.$store.state.native.smphMchtlUniqNo });
        this.$parent.$refs.approvalLine.open();
      } else if (value === "NOMATCH") {
        this.scanSelfieDataNoMatch = true;
      }
    },
  },
  data() {
    return {
      lvbdInfoRegiYnPopupOpen: false,
      scanSelfieDataNoMatch: false,
    };
  },
  methods: {
    scanSelfieCall() {
      this.$set(this, "scanSelfieDataMatch", ""); //검증성공여부 초기화

      //생체정보등록or검증 구분값(0:등록, 1:검증)
      this.$bridge.scanSelfieData(this.siteCode, this.sessionInfo.userInfo.nativYn, this.sessionInfo.userInfo.lvbdCertnUniqID, this.sessionInfo.userInfo.baseUrl);
    },
  },
};
</script>
